import React from "react";
import { useTranslation } from "react-i18next";

// Condensed pagination: first, last, current ±1, with ellipses.
// Props: page (current), totalPages, onChange(pageNumber)
const Pagination = ({ page, totalPages, onChange }) => {
  const { t } = useTranslation();
  if (!totalPages || totalPages <= 1) return null;

  const go = (p) => {
    if (p < 1 || p > totalPages || p === page) return;
    onChange(p);
  };

  // Build the list of page numbers with ellipsis markers ("...").
  const pages = [];
  const window = 1; // pages on each side of current
  const push = (p) => pages.push(p);

  const left = Math.max(2, page - window);
  const right = Math.min(totalPages - 1, page + window);

  push(1);
  if (left > 2) pages.push("left-ellipsis");
  for (let p = left; p <= right; p++) push(p);
  if (right < totalPages - 1) pages.push("right-ellipsis");
  if (totalPages > 1) push(totalPages);

  return (
    <nav aria-label="pagination">
      <ul className="pagination justify-content-center">
        <li className={"page-item" + (page === 1 ? " disabled" : "")}>
          <button className="page-link" onClick={() => go(page - 1)}>
            {t("pagination.previous")}
          </button>
        </li>

        {pages.map((p, i) =>
          typeof p === "string" ? (
            <li key={p + i} className="page-item disabled">
              <span className="page-link">…</span>
            </li>
          ) : (
            <li key={p} className={"page-item" + (p === page ? " active" : "")}>
              <button className="page-link" onClick={() => go(p)}>
                {p}
              </button>
            </li>
          )
        )}

        <li className={"page-item" + (page === totalPages ? " disabled" : "")}>
          <button className="page-link" onClick={() => go(page + 1)}>
            {t("pagination.next")}
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
